import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export const EasypaisaUserInfoResponseType = Type.Object({
	openId: Type.String(),
	unionId: Type.String(),
	userMsisdn: Type.String(),
	userName: Type.String(),
	userCnic: Type.String(),
});

export type EasypaisaUserInfoResponse = Static<
	typeof EasypaisaUserInfoResponseType
>;

export interface EasypaisaUserInfo {
	userName: string;
	userCnic: string;
	phoneNumber: string;
}
